import { render, staticRenderFns } from "./pageHead.vue?vue&type=template&id=33f4df19&"
import script from "./pageHead.vue?vue&type=script&lang=js&"
export * from "./pageHead.vue?vue&type=script&lang=js&"
import style0 from "./pageHead.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports